import React, { useEffect } from "react";
import { usePageMetadata } from "../context/PageMetadataContext";
import { useLanguage } from "../context/LanguageContext";

const MaintenancePage: React.FC = () => {
  const { setHeading, setTitle, setDescription } = usePageMetadata();
  const { t, language } = useLanguage();

  useEffect(() => {
    setHeading(t("maintenance.heading"));
    setTitle(t("maintenance.title"));
    setDescription(t("maintenance.description"));
  }, [setHeading, setTitle, setDescription, t, language]);

  return (
    <main className="maintenance-page">
      <section className="maintenance-panel">
        <div className="maintenance-status">{t("maintenance.status")}</div>
        <h1>{t("maintenance.page_title")}</h1>
        <p className="maintenance-lead">
          {t("maintenance.message")}
        </p>

        <div className="maintenance-info">
          <div>
            <span>{t("maintenance.protocol_label")}</span>
            <strong>{t("maintenance.protocol_value")}</strong>
          </div>
          <div>
            <span>{t("maintenance.affected_label")}</span>
            <strong>{t("maintenance.affected_value")}</strong>
          </div>
          <div>
            <span>{t("maintenance.eta_label")}</span>
            <strong>{t("maintenance.eta_value")}</strong>
          </div>
        </div>

        <p className="maintenance-note">
          {t("maintenance.note")}
        </p>
      </section>
    </main>
  );
};

export default MaintenancePage;
